import { copy } from "plos/src/styles/copy.css";
import { Trans } from "react-i18next";

const PointsHelp = () => (
  <div className={copy}>
    <Trans ns="help" i18nKey="contextualHelp.points.description">
      <p>
        Your players score points according to real-life match events such as
        goals, assists, clean sheets, saves, defensive contributions and bonus
        points.
      </p>
      <p>
        Your captain scores double points, so that selection is an important
        decision each Gameweek.
      </p>
      <p>
        Players on the bench only contribute to your overall Gameweek score if
        they automatically substitute in for a starting player who does not
        play.
      </p>
      <p>
        Chips can boost your points in a Gameweek, but you can only play one
        chip in a Gameweek. The Triple Captain chip triples rather than doubles
        your captain’s score. The Bench Boost chip allows all your bench players
        to contribute to your Gameweek total.
      </p>
    </Trans>
  </div>
);

export default PointsHelp;
